import React from 'react';
import logoWhite from '../images/logo-white.png';

function AboutSection() {
    const year = new Date().getFullYear();
    return (
        <footer id="about" className="bd-footer">
            <div>
                <div className="bd-footer__brand">
                    <div className="bd-footer__brand-logo">
                        <img src={logoWhite} alt="Raj Printers & Associates Logo" />
                    </div>
                    <div className="bd-footer__brand-name">Raj Printers & Associates</div>
                </div>
                <p className="bd-footer__about">
                    Putting ink to paper for Jaipur since 1981. Your imagination is limitless,
                    and so are our printing capabilities — from irregular handouts to specialty
                    cuts, custom packaging to personalised gifts. If it takes ink, we can print it.
                </p>
            </div>
            <div>
                <div className="bd-footer__col-label">Hours</div>
                <ul className="bd-footer__list">
                    <li>Mon — Sat · 9:30 to 8:00</li>
                    <li>Sunday · Closed</li>
                    <li className="accent">WhatsApp · 24/7</li>
                </ul>
            </div>
            <div>
                <div className="bd-footer__col-label">Catalogue</div>
                <ul className="bd-footer__list">
                    <li><a href="#work">Wedding Cards</a></li>
                    <li><a href="#work">Stamps</a></li>
                    <li><a href="#work">Bill Books</a></li>
                    <li><a href="#work">Wide Format</a></li>
                </ul>
            </div>
            <div>
                <div className="bd-footer__col-label">Reach us</div>
                <ul className="bd-footer__list">
                    <li><a href="tel:+919982066620">+91 99820 666 20</a></li>
                    <li><a href="mailto:rajprinters81@gmail.com">rajprinters81@gmail.com</a></li>
                    <li>Govind Marg, Raja Park</li>
                </ul>
            </div>
            <div className="bd-footer__rule">
                <span>© {year} Raj Printers & Associates</span>
            </div>
        </footer>
    );
}

export default AboutSection;
